$(function () {
  const $orderAlertPopup = $('#order-alert-popup');
  if ($orderAlertPopup.length <= 0) return false;

  window.dAgency.showOrderAlertPopup = () => {
    $orderAlertPopup.addClass('visible');
  }

  window.dAgency.hideOrderAlertPopup = () => {
    $orderAlertPopup.removeClass('visible');
  }

  $(document).on('click', '.cart__checkout.trigger-alert-popup', function (e) {
    e.preventDefault();
    window.dAgency.showOrderAlertPopup();
  });

  $(document).on('click', '.order-alert-popup__close', function () {
    window.dAgency.hideOrderAlertPopup();
  });
});
